'use strict'

import Settings from '@/pages/Settings/Settings.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/settings',
    name: 'Settings',
    component: Settings,
    beforeEnter: ifAuthenticated
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/setting.js